import React from "react";
import "../../App.css";

export default function Terms() {
  return (
    <div className="terms-container">
      <h1 className="terms">CODE OF CONDUCT-STUDENT</h1>
      <div className="terms-info">
        <h2>State Principles</h2>
        <ul>
              <li>&#8226; Treat others fairly</li>
              <li>&#8226; Learn in a safe, supportive and comfortable environment</li>
              <li>&#8226; Gain assistance from teachers who are approachable, supportive, patent and encouraging</li>
        </ul>
        <h2>Examples of Rules</h2>
        <ul>
              <li>&#8226; Behave in a way which shows respect for others</li>
              <li>&#8226; Not to disrupt other students</li>
              <li>&#8226; Obey the schools rules and procedures</li>
              <li>&#8226; Not fight, bully, tease or torment other members of the school or its community</li>
              <li>&#8226; Respect the property of the school and other students</li>
              <li>&#8226; Participate in extra-curricular activities, programs, excursions, etc.</li>
        </ul>
        <h2>Strategies</h2>
        <ul>
              <li>&#8226; Inform the students and parents of the school rules</li>
              <li>&#8226; Provide SAFE, SECURE AND SUPPORTIVE ENVIRONMENT</li>
              <li>&#8226; Inform students of activities available to them</li>
              <li>&#8226; Ensure equal and fair treatment of all students by both staff and students of the school</li>
              <li>&#8226; Provide a school environment, which is clean, harmonious and free of physical or verbal abuse</li>
        </ul>
        <h2>Sanctions</h2>
        <ul>
              <li>&#8226; Referral to Principal</li>
              <li>&#8226; Warning</li>
              <li>&#8226; Parent Contact and/or interview</li>
              <li>&#8226; Decision on students’ improper attributes to school and learning policy and regulation</li>
        </ul>
      </div>
    </div>
  );
}
